import React, { Fragment } from "react";
import { zl } from "../../../functions/utilities.js";

const MieszkaniecWydrukStawkiJednorazoweInd = props => {

    const { stawkiJednorazoweInd, licznikJednorazowe } = props;

    const puste = Array(3).fill(null).map((_, index) => (
        <td 
            style={{
                borderLeft: '1px solid black', 
                borderRight: '1px solid black',
                padding: '1mm 2mm',
                textAlign: 'center',
            }}
            key={index}
        >    
        </td>
    ));

    const tabela3 = s => {
        let currentMaxI = licznikJednorazowe; 
        return s?.map( (stawka, i) => (
            <tr key={i}>
                <td 
                    style={{
                        borderLeft: '1px solid black', 
                        borderRight: '1px solid black',
                        padding: '1mm 2mm',
                        textAlign: 'center',
                    }}
                >    
                    { ++currentMaxI }
                </td>
                <td 
                    style={{
                        borderLeft: '1px solid black', 
                        borderRight: '1px solid black',
                        padding: '1mm 2mm'
                    }}
                >    
                    { stawka?.opis }
                </td>
                { puste }
                <td 
                    style={{
                        borderLeft: '1px solid black', 
                        borderRight: '1px solid black',
                        padding: '1mm 2mm',
                        textAlign: 'right',
                        whiteSpace: 'nowrap'
                    }}
                >    
                    { zl(stawka.kwota) }
                </td>
        </tr>
        ))
    }

    return (
        <Fragment>
            { tabela3(stawkiJednorazoweInd) }
        </Fragment>
    )
}

export default MieszkaniecWydrukStawkiJednorazoweInd;